import { render, staticRenderFns } from "./ProjectsGrid.vue?vue&type=template&id=7f5bc41e&scoped=true&"
import script from "./ProjectsGrid.vue?vue&type=script&lang=js&"
export * from "./ProjectsGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsGrid.vue?vue&type=style&index=0&id=7f5bc41e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5bc41e",
  null
  
)

export default component.exports